import { BCAHeaderWithAPI, BCAFooter } from "@bca/ui-library";

const isProd = process.env.ENVIRONMENT === "production";
const isUat = process.env.ENVIRONMENT === "prev";

const magnoliaRootUrl = isProd
  ? "https://www.bca.co.uk/"
  : isUat
    ? "https://cms.uat.britishcarauctions.net/"
    : "https://cmsmain-dev.bca.co.uk/";

const Layout = (props: {
  user?: { firstName: string; lastName: string };
  idToken?: string;
  isToUseAuthZero: boolean;
  isAuthenticated: boolean;
  children: any;
  logoutUrl?: string;
}) => {
  const onHandleLogout = () => {
    if (props.isToUseAuthZero && props.isAuthenticated && props.logoutUrl) {
      {
        window.location.href = props.logoutUrl;
      }
    }
  };

  return (
    <>
      <BCAHeaderWithAPI
        urls={{
          myBCAInfo: `${magnoliaRootUrl}.rest/delivery/menu-links/UK/MyBCA-Menu`,
          navLinks: `${magnoliaRootUrl}.rest/delivery/menu-links/UK/Main-Menu`,
          searchRootURL: magnoliaRootUrl,
          login: "",
          logout: props.isToUseAuthZero
            ? null
            : process.env.isProd
              ? `https://login.bca.co.uk/connect/endsession?id_token_hint=${props.idToken}&post_logout_redirect_uri=https://www.bca.co.uk`
              : `https://login.uat.britishcarauctions.net/connect/endsession?id_token_hint=${props.idToken}&post_logout_redirect_uri=https://cms.uat.britishcarauctions.net`,
          vehicleOptions: process.env.isProd
            ? "https://auctionview.bca.co.uk/buyer/api/v1_0/FacetedSearchApi/VehicleTypes?cultureCode=en"
            : "https://auctionview.uat.britishcarauctions.net/buyer/api/v1_0/FacetedSearchApi/VehicleTypes?cultureCode=en",
          auctionViewRoot: process.env.isProd
            ? "https://auctionview.bca.co.uk/"
            : "https://auctionview.uat.britishcarauctions.net/",
          trackedLink: isProd
            ? "https://www.bca.co.uk/search?requestOrigin=Tracked"
            : "https://cms.uat.britishcarauctions.net/search?requestOrigin=Tracked",
        }}
        user={props.user}
        onSignOutClick={onHandleLogout}
      />
      <div style={{ minHeight: "100vh" }}>{props.children}</div>
      <BCAFooter
        urls={{
          navigationLinks: `${magnoliaRootUrl}.rest/delivery/menu-links/UK/Footer`,
          legalInfo: `${magnoliaRootUrl}.rest/delivery/menu-links/UK/Footer-Legal`,
          socialMedia: `${magnoliaRootUrl}.rest/delivery/menu-links/UK/Social-Links`,
        }}
      ></BCAFooter>
    </>
  );
};

export default Layout;
